<h1>Favourite Artists</h1>
<h3>Artists you have saved ({{favourites.count()}} / {{favourites.max}}). Click the heart on any artist to save or remove them.</h3>

<div class="filters">
  <div class="search-row">
    <input type="search" class="search-box" placeholder="Search your favourite artists"
      aria-label="Search your favourite artists" [value]="query()" (input)="setQuery($any($event.target).value)" />
    <label class="control">
      <span>Sort</span>
      <select (change)="setSort($any($event.target).value)">
        <option value="popular" [selected]="sort() === 'popular'">Most popular</option>
        <option value="az" [selected]="sort() === 'az'">A to Z</option>
        <option value="added" [selected]="sort() === 'added'">Recently added</option>
      </select>
    </label>
    @if (query() || sort() !== 'popular') {
    <button type="button" class="filter-chip" (click)="clearFilters()">Clear filters</button>
    }
  </div>
</div>

@if (error()) {
<p class="status error">{{error()}}</p>
}

<div class="container">
  @if (!loading() && pool().length === 0 && !error()) {
  <p class="status">No favourite artists yet. Click the heart on any artist, on Top Artists, an artist or album page, search results
    or related artists, to save them here. <a routerLink="/new-releases">Browse Top Albums</a></p>
  } @else {
  <app-artist-grid [artists]="visible()" [favouriteIds]="favourites.ids()" (favouriteToggle)="toggleFavourite($event)" />

  @if (!loading() && visible().length === 0 && pool().length > 0) {
  <p class="status">No saved artists match your search.</p>
  }

  <app-pager [page]="page()" [pages]="pages()" (pageChange)="setPage($event)" />
  @if (filtered().length > 0) {
  <p class="status count">{{filtered().length}} of {{pool().length}} artists &middot; page {{page()}} of {{pages()}}</p>
  }
  }
</div>
